/* import __COLOCATED_TEMPLATE__ from './show.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class TopicShowComponent extends Component {
  @service conversationalInsights;
  @service intercomEventService;

  @tracked botInboxTime;

  get botInboxTimeExcluded() {
    return this.botInboxTime === 'excluded';
  }

  @action
  updateRange(range) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'filtered',
      object: 'conversations',
      place: 'topics',
    });

    this.conversationalInsights.updateRange(range);
  }
}
